import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'
import {
  ActorSearchPreview,
  CampaignSearchPreview,
  CveSearchPreview,
  IndicatorSearchPreview,
  MalwareSearchPreview,
  ReportSearchPreview
} from './searchPreviewComp'
import { AdaptedMATIApiProvider } from '../../MATIApiProvider'

const ActorSearchResultPreview = (data) => <ActorSearchPreview {...data}/>
const MalwareSearchResultPreview = (data) => <MalwareSearchPreview {...data}/>
const CveSearchResultPreview = (data) => <CveSearchPreview {...data}/>
const IndicatorSearchResultPreview = (data) => <IndicatorSearchPreview {...data} />
const ReportSearchResultPreview = (data) => <ReportSearchPreview {...data} />
const CampaignSearchResultPreview = (data) => <CampaignSearchPreview {...data}/>

const compMap = {
  'threat-actor': ActorSearchResultPreview,
  malware: MalwareSearchResultPreview,
  vuln: CveSearchResultPreview,
  fqdn: IndicatorSearchResultPreview,
  md5: IndicatorSearchResultPreview,
  sha256: IndicatorSearchResultPreview,
  sha1: IndicatorSearchResultPreview,
  ipv4: IndicatorSearchResultPreview,
  url: IndicatorSearchResultPreview,
  indicator: IndicatorSearchResultPreview,
  report: ReportSearchResultPreview,
  campaign: CampaignSearchResultPreview
}

export const SearchResultPreview = ({ type, data }) => {
  if (!type) return null
  const CompTemplate = compMap[type] || null
  return (
    <AdaptedMATIApiProvider>
      <Box padding='spacePaddingXLarge'>
        <CompTemplate data={data}/>
      </Box>
    </AdaptedMATIApiProvider>
  )
}

SearchResultPreview.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
}
